/**
 * Converts the first character of each word in a string to uppercase and the remaining characters to lowercase.
 * If a word is already in uppercase and has more than one character, it remains unchanged.
 *
 * @param {string} str - The input string to be transformed.
 * @returns {string} - The transformed string with each word's first character in uppercase.
 */
export const ucwords = (str: string): string =>
  str
    .split(" ")
    .map((word) =>
      word.length > 1 && word === word.toUpperCase()
        ? word
        : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
    )
    .join(" ");
